import React from 'react'
import { ButtonBase, makeStyles, Badge } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 4,
    gap: 8,
    backgroundColor: GRAY_COLORS[50],
    borderRadius: 8,
    border: `1px solid ${GRAY_COLORS[100]}`
  }
}))

const TaskSwitcher = ({
  isClosedTasks,
  onChange = isClose => {},
  style = {},
  taskCounts
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root} style={style}>
      <ButtonSwitch
        isActive={!isClosedTasks}
        text={'Открытые'}
        onClick={() => onChange(false)}
        taskCount={taskCounts?.open}
      />
      <ButtonSwitch
        isActive={isClosedTasks}
        text={'Закрытые'}
        onClick={() => onChange(true)}
        taskCount={taskCounts?.closed}
      />
    </div>
  )
}
export default TaskSwitcher

const ButtonSwitch = ({ text, onClick, isActive, taskCount }) => {
  const useStyles = makeStyles(theme => ({
    root: {
      background: isActive ? '#FFFFFF' : 'transparent',
      color: isActive ? GRAY_COLORS[700] : GRAY_COLORS[500],
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '20px',
      borderRadius: 6,
      width: '100%',
      display: 'flex',
      padding: '8px 12px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 8
    }
  }))
  const classes = useStyles()

  return (
    <Badge badgeContent={taskCount} color="primary" style={{width:"45%"}} max={9999}>
      <ButtonBase onClick={onClick} className={classes.root}>
        {text}
      </ButtonBase>
    </Badge>
  )
}
